import axios from '../helpers/Axios'

export default {

  async loadCompany(companyId) {
    return await axios.get("/Company/" + companyId,  {timeout: 1000 * 120});
  },
  async getCurrentUser() {
    return await axios.get("/User/GetCurrentUser");
  },
  async loadCompanyVendors(companyId) {
    return await axios.get("/Company/" + companyId + "/vendors");
  },
  async loadCompanyHistory(companyId) {
    return await axios.get("/Company/" + companyId + "/history");
  },
  async loadCompanyFinances(companyId) {
    return await axios.get("/Company/" + companyId + "/finances");
  },
  async loadMainContact(companyId) {
    return await axios.get("/CompanyVendor/main/" + companyId);
  },
  async loadCompanyQualifications(companyId) {
    return await axios.get("/CompanyQualification/" + companyId);
  },
  async saveCompanyQualifications(qualification) {
    return await axios.post("/CompanyQualification", qualification);
  },
  async saveAndSendCompanyQualification(qualification) {
    return await axios.post("/CompanyQualification/senddirector", qualification);
  },
  async loadCompanyPreQualifications(companyId) {
    return await axios.get("/CompanyPreQualification/" + companyId);
  },
  async saveCompanyPreQualification(preQualification) {
    return await axios.post("/CompanyPreQualification", preQualification);
  },
  async saveAndSubmitCompanyPreQualification(preQualification) {
    return await axios.post("/CompanyPreQualification/submit", preQualification);
  },
  async loadMainContactGroup(companyId) {
    return await axios.get("/company/" + companyId + "/group");
  },
  async loadSystemsStatuses(companyId) {
    return await axios.get("/company/" + companyId + '/statuses');
  },
  async saveCompanyContactInformation(body) {
    await axios.post("/company/contact", body);
  },
  async saveCompanyVendor(body) {
    await axios.post("/companyvendor", body);
  },
  async deleteCompanyVendor(vendorId) {
    await axios.delete("/companyvendor/" + vendorId);
  },
  async setMainContact(vendorId) {
    await axios.post("/companyvendor/setmain/" + vendorId);
  },
  async findTransfer(transferCode) {
    return await axios.get("/company/findtransfer/" + encodeURIComponent(transferCode));
  },
  async completeTransfer(companyId) {
    return await axios.post("/company/completetransfer/" + companyId);
  },
  async sendBrochure(vendorId, type) {
    return await axios.post("/companyvendor/sendBrochure/" + vendorId + '/' + type);
  },
  async getLinkedCompanies(companyId) {
    return await axios.get("/company/linked/" + companyId);
  },
  async addLinkedCompany(linkedCompany) {
    return await axios.post("/company/linked/", linkedCompany);
  },
  async sendTransfer(qualificationId) {
    return await axios.post("/companyqualification/send/" + qualificationId);
  },
  async saveSuppression(suppression) {
    return await axios.post("/company/suppression", suppression);
  },
  async saveCompanyFinances(finance) {
    return await axios.post("/Company/finances", finance);
  },
  async saveCompanyFinanceNote(financeNote) {
    return await axios.post("/Company/financeNote", financeNote);
  },
  async deleteCompanyFinances(financeId) {
    return await axios.delete("/Company/finances/" + financeId);
  },
  async saveCompanySectors(sectors) {
    return await axios.post("/Company/sectors", sectors);
  },
  async saveCompanyTags(tags) {
    return await axios.post("/Company/tags", tags);
  },
  async saveCompany(newCompany) {
    return await axios.put("/Company", newCompany);
  },
  async saveRearrangeCallback(newCompany) {
    return await axios.post("/Company/rearrangeCallback", newCompany);
  },
  async getCallbacks() {
    return await axios.get("/company/callbacks");
  },
  async getFilteredCallbacks(filters) {
    return await axios.post("/company/filteredcallbacks", filters, {timeout: 1000 * 30});
  },
  async saveOverview(overview) {
    return await axios.post("/company/overview", overview);
  },
  async clearCallback(callback) {
    return await axios.post("/company/clearcallback", callback);
  },
  async getCallbackCount() {
    return await axios.get("/company/callbackCount");
  },
  async savePreQualificationCallback(callback) {
    return await axios.post('/company/preQualificationCallback', callback);
  },
  async getCompanyCrossSellHistory(companyId){
    return await axios.get('/company/getCompanyCrossSellHistory/' + companyId);
  },
}

